// export const BASE_URL = "https://api.make-my.shop"
// export const BASE_URL = "http://localhost:4000"    // For local debugging
// export const BASE_URL = "https://multivernder-ecommerce-9wuu.onrender.com" // render deployment
export const BASE_URL = "https://be-api.tpggroup.in" // cooliefy deployment
export const server = `${BASE_URL}/api/v2`;
export const SOCKET_CHAT_URL = "http://socket.tpggroup.in"
export const google_map_api_key = "AIzaSyBsmZbeP1_kuAHiZMqKA7a0J7ch_rNWe_g"